import { Tag, TagsAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';

export interface ITagsProps {
    entityTypes?: string[];
    exceptEntityTypes?: string;
    isModeEditing?: boolean;
    isHeaderIgnored?: boolean;
    context?: string[];
    groupIds?: string[];
    status?: number[];
    types?: number[];
    symbols?: string[];
    name?: string;
    limit?: number;
    search?: string[];
    lang?: string;
}

export const useTagsList = (request: ITagsProps | null, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTagsTree, request, lang, t, disabled, shouldCacheValues);

export const useTags = (request: { tagIds: string[] }, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTags, request, lang, t, disabled, shouldCacheValues);import { Tag, TagsAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';

export interface ITagsProps {
    entityTypes?: string[];
    exceptEntityTypes?: string;
    isModeEditing?: boolean;
    isHeaderIgnored?: boolean;
    context?: string[];
    groupIds?: string[];
    status?: number[];
    types?: number[];
    symbols?: string[];
    name?: string;
    limit?: number;
    search?: string[];
    lang?: string;
}

export const useTagsList = (request: ITagsProps | null, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTagsTree, request, lang, t, disabled, shouldCacheValues);

export const useTags = (request: { tagIds: string[] }, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTags, request, lang, t, disabled, shouldCacheValues);